const Connect = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.8861 4.21069C16.322 3.87162 16.9503 3.95016 17.2894 4.38611L20.7894 8.88611C21.0238 9.18759 21.0661 9.5963 20.8983 9.9394C20.7305 10.2825 20.3819 10.5 20 10.5H4C3.44772 10.5 3 10.0523 3 9.50005C3 8.94776 3.44772 8.50005 4 8.50005H17.9554L15.7106 5.61399C15.3716 5.17804 15.4501 4.54976 15.8861 4.21069Z'
        fill='#747487'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.11394 20.7893C7.67799 21.1284 7.04972 21.0498 6.71065 20.6139L3.21065 16.1139C2.97616 15.8124 2.93388 15.4037 3.10169 15.0606C3.26949 14.7175 3.61807 14.5 4 14.5L20 14.5C20.5523 14.5 21 14.9477 21 15.5C21 16.0522 20.5523 16.5 20 16.5L6.04464 16.5L8.28935 19.386C8.62842 19.822 8.54989 20.4502 8.11394 20.7893Z'
        fill='#747487'
      />
    </svg>
  )
}

export default Connect
